import { forwardRef } from 'react';
import { Select } from '@hotjar/hotsauce';
import { COUNTRIES } from '@hotjar/country-lib';

interface CountryDropdownProps {
  isInvalid: boolean;
  placeholder: string;
}

export const CountryDropdown = forwardRef<HTMLSelectElement, CountryDropdownProps>(
  ({ isInvalid, placeholder }, ref): JSX.Element => {
    return (
      <Select id="country" name="country" ref={ref} isRequired isInvalid={isInvalid}>
        <option value="" disabled>
          {placeholder}
        </option>
        {COUNTRIES.map(({ label, value }) => (
          <option value={value} key={value}>
            {label}
          </option>
        ))}
      </Select>
    );
  },
);
